import type { ReactNode } from 'react';
import { Logo } from './Logo.js';
import '../../pages/auth-page.css';

/**
 * Port of the Adcredo-Ai sign-in layout: full-bleed drifting gradient panel on
 * the left (53%), white form column on the right. Proptree palette and type;
 * logo pinned to the panel's top-left corner. See auth-page.css for the
 * colour/font substitutions.
 */
export function AuthShell({
  children,
  eyebrow = 'Welcome back',
  headline,
  description,
}: {
  children: ReactNode;
  eyebrow?: string;
  headline?: ReactNode;
  description?: ReactNode;
}) {
  return (
    <main className="auth-shell">
      <section className="auth-panel" aria-label="Proptree admin console">
        <div className="auth-field" aria-hidden="true" />
        <div className="auth-orb auth-orb-light" aria-hidden="true" />
        <div className="auth-orb auth-orb-deep" aria-hidden="true" />
        <div className="auth-bloom" aria-hidden="true" />
        <div className="auth-grain" aria-hidden="true" />

        <div className="auth-brand">
          <Logo size="md" />
        </div>

        <div className="auth-panel-copy">
          <p className="auth-eyebrow">{eyebrow}</p>
          <h2>
            {headline ?? (
              <>
                Every brokerage.
                <br />
                <em>One console.</em>
              </>
            )}
          </h2>
          <p className="auth-panel-description">
            {description ?? (
              <>
                <strong>Agencies, agents, listings and cron</strong> — every
                brokerage on proptr.ee, operated from a single interface.
              </>
            )}
          </p>
        </div>
      </section>

      <section className="auth-form-column">
        {children}

        <nav className="auth-legal" aria-label="Legal and support">
          <a href="/privacy">Privacy &amp; terms</a>
          <a href="/contact">Contact us</a>
          <a href="/support">Support</a>
        </nav>
      </section>
    </main>
  );
}

export function AlertIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.9" />
      <path d="M12 7.5V13M12 16.2v.1" stroke="currentColor" strokeWidth="1.9" />
    </svg>
  );
}

export function ArrowIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
